import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { WalletBalanceRequestModel } from 'src/app/models/request/wallet-balance-request.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WalletBalanceService {

  constructor(private _httpClient: HttpClient) { }

  processWalletBalance(walletBalanceRequestModel: WalletBalanceRequestModel): Observable<boolean> {
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletBalance.ProcessWalletBalance}`,
      walletBalanceRequestModel);
  }
}
